import React from "react";
import { TrendingUp } from "lucide-react";
import Layout from "../components/Layout";
import { earningsBreakdown, recentTx } from "../data/mockData";

export default function Earnings() {
  const total = earningsBreakdown.reduce((sum, e) => sum + parseFloat(e.amount), 0);

  return (
    <Layout title="My Earnings">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6">
        <div className="rounded-2xl border border-[#1B2033] bg-[#0E1220] p-6">
          <div className="flex items-center gap-2 mb-4">
            <TrendingUp size={18} className="text-[#3FBF8F]" />
            <h2 className="font-semibold text-[15px]">Earnings Breakdown</h2>
          </div>
          <div className="space-y-3">
            {earningsBreakdown.map((e, i) => (
              <div key={i} className="flex items-center justify-between px-4 py-3 rounded-lg bg-[#161B2C]">
                <div className="flex items-center gap-2">
                  <div className="w-2.5 h-2.5 rounded-full" style={{ background: e.color }} />
                  <span className="text-sm">{e.label}</span>
                </div>
                <span className="text-sm font-medium" style={{ color: e.color }}>
                  {e.amount} USDT
                </span>
              </div>
            ))}
          </div>

          <h2 className="font-semibold text-[15px] mt-6 mb-3">Recent Earning History</h2>
          <div className="space-y-3">
            {recentTx.filter((t) => t.type === "Daily Earning").map((tx, i) => (
              <div key={i} className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium">{tx.type}</div>
                  <div className="text-[11px] text-[#7C8AA5]">{tx.date}</div>
                </div>
                <div className="text-sm font-medium text-[#3FBF8F]">{tx.amount} USDT</div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-2xl border border-[#1B2033] bg-[#0E1220] p-5 h-fit">
          <div className="text-[11px] uppercase tracking-widest text-[#7C8AA5] mb-3">
            Total Earned
          </div>
          <div className="text-3xl font-semibold text-[#3FBF8F] mb-1">
            {total.toFixed(2)} <span className="text-sm font-normal text-[#7C8AA5]">USDT</span>
          </div>
          <div className="text-xs text-[#7C8AA5]">Across all sources</div>
        </div>
      </div>
    </Layout>
  );
}